import type { JssStyle } from 'jss';
import type { TranslateService } from '@ngx-translate/core';
import type { WebWidgetModel } from '@web/types';
import type { TimerWidgetData } from '@web/widgets/timer/type/timer-widget.type';

import { EHorizontalPosition, ESize, ETime, Widgets, ETimerAppearanceSeparator } from '@common/enums';
import { defaultWidgetParams, defaultWidgetPermission } from '@common/constants';
import { getNextDayFromNow } from '@common/helpers';

import { TimerViewComponent } from '@web/widgets/timer/components/timer-view/timer-view.component';
import { TimerControlComponent } from '@web/widgets/timer/components/timer-control/timer-control.component';
import type { RemainingTimeNumericType } from '@components/sp-timer/src/types/timer.type';
import { ETimerType } from '@components/sp-timer/src/types/timer.type';

// DEFAULT COMPONENT SETTINGS
const timerData = (translateService: TranslateService): TimerWidgetData => ({
    timerType: ETimerType.fixed,
    untilDate: getNextDayFromNow(),
    remainingTime: DEFAULT_REMAINING_TIME,
    autorestart: false,
    expiredText: translateService.instant('control_timer_expired_text_placeholder'),
    columns: [ETime.days, ETime.hours, ETime.minutes, ETime.seconds],
    themeTextColor: null,
    themeDividerColor: null,
    textColor: '#000000',
    dividerColor: '#000000',
    customLabels: {
        days: translateService.instant('days'),
        hours: translateService.instant('hours'),
        minutes: translateService.instant('minutes'),
        seconds: translateService.instant('seconds'),
    },
    appearance: ETimerAppearanceSeparator.none,
    size: ESize.M,
    horizontalAlign: EHorizontalPosition.M,
    mobileSize: ESize.S,
    mobileHorizontalAlign: EHorizontalPosition.M,
    tabletSize: ESize.S,
    tabletHorizontalAlign: EHorizontalPosition.M,
    isSynchronizeStyle: true,
    hideOnMobile: false,
    hideOnTablet: false,
    hideOnDesktop: false,
    position: {
        width: 100,

        x: 0,
        y: 0,
        rotate: 0,
        zIndex: 0,
        mobileX: 0,
        mobileY: 0,
        mobileRotate: 0,
        mobileZIndex: 0,
    },
});

const DEFAULT_REMAINING_TIME: RemainingTimeNumericType = {
    days: 0,
    hours: 11,
    minutes: 59,
    seconds: 59,
};

const timerStyles: JssStyle = {};
// END DEFAULT SETTINGS

export const timerWidgetModel: WebWidgetModel = {
    componentView: TimerViewComponent,
    componentControl: TimerControlComponent,
    name: Widgets.TIMER,
    label: 'widget_timer_label',
    data: timerData,
    styles: timerStyles,
    permission: defaultWidgetPermission,
    params: defaultWidgetParams,
};
